import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bda0822c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bda0822c')) {
      api.createRecord('bda0822c', component.options)
    } else {
      api.reload('bda0822c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bda0822c&", function () {
      api.rerender('bda0822c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/referral_programs/index.vue"
export default component.exports